export const worker = new Worker(new URL('./dbWorker.ts', import.meta.url), {
  type: 'module'
});
